import { useLocation, useNavigate } from 'react-router-dom';
import { contentActionsService } from '../../../utils/ContentActionsService/ContentActionsService';
import { useEventSource } from '../../../utils/LocationContext';
import { useIsMobile } from '../../../utils/getIsMobile';
import { openExternalLink } from '../../../utils/openExternalLink';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Button } from '../../input/Button';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { LEARN_MORE_URL, PARTNER_REGISTRATION_PATH } from './constants';

export const CpaTrialRegistrationDialog = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const t = useTranslation();
    const isMobile = useIsMobile();
    const { eventSource } = useEventSource();

    const handleClose = () => {
        navigate(-1);
    };

    const handleLearnMore = () => {
        if (eventSource) {
            contentActionsService.trackRewardDetailsClick({
                screen: eventSource,
            });
        }
        openExternalLink(LEARN_MORE_URL);
    };

    const handleRegister = () => {
        if (eventSource) {
            contentActionsService.trackRewardRegisterClick({
                screen: eventSource,
            });
        }
        navigate(PARTNER_REGISTRATION_PATH, {
            state: { redirectUrl: location.pathname },
        });
    };

    const titleContent = (
        <Typography variant="title2" weight="bold">
            {t('Получить награду')}
        </Typography>
    );

    const mainContent = (
        <Flex direction="column" spacing={4}>
            <Flex direction="column" spacing={1.5}>
                <Typography variant="body">
                    {t(
                        'Ваши публикации помогли бизнесам в продвижении их товара. Вы можете получить за это вознаграждение, подробные условия — в договоре. Направьте заявление на заключение договора, а мы его рассмотрим и сообщим вам о результатах проверки.',
                    )}
                </Typography>

                <Typography variant="body">
                    {t('Обратите внимание: вывод доступен только самозанятым, ИП и юрлицам.')}
                </Typography>
                <Typography>
                    {t(
                        'Если договор не будет заключён в течение полугода с момента начала накопления вознаграждения, все накопления аннулируются.',
                    )}
                </Typography>
            </Flex>

            <Flex width="100%" direction={isMobile ? 'column' : 'row'} spacing={1}>
                <Button
                    color="secondary"
                    variant="filled"
                    size="l"
                    onClick={handleLearnMore}
                    width="100%"
                    style={{ letterSpacing: '0.7px' }}
                >
                    {t('Подробнее')}
                </Button>

                <Button
                    variant="filled"
                    size="l"
                    onClick={handleRegister}
                    width="100%"
                    style={{ letterSpacing: '0.7px' }}
                >
                    {t('Заключить договор')}
                </Button>
            </Flex>
        </Flex>
    );

    return (
        <SmartDrawer
            onClose={handleClose}
            titleContent={titleContent}
            mainContent={mainContent}
            forceCloseButton={true}
            hideTrigger={true}
        />
    );
};
